(function () {
  'use strict';

  const emptyEl  = document.querySelector('[data-packora-cart-empty]');
  const footerEl = document.querySelector('[data-packora-cart-footer]');

  if (!emptyEl && !footerEl) return;

  // ------------------------------------------------------------
  // Packora – Apple-style micro motion (inject once)
  // ------------------------------------------------------------
  const STYLE_ID = 'pk-cart-empty-motion';
  const injectMotionCSS = () => {
    if (document.getElementById(STYLE_ID)) return;

    const css = `
      :root{
        --pk-blue:#2F5BFF;
        --pk-green:#00C48C;
      }

      /* EMPTY CARD: fade + lift + blur */
      [data-packora-cart-empty]{
        display:block;
        opacity:0;
        transform: translateY(10px) scale(.99);
        filter: blur(6px);
        transition:
          opacity 260ms ease,
          transform 260ms ease,
          filter 260ms ease;
        will-change: opacity, transform, filter;
      }
      [data-packora-cart-empty][data-pk-visible="1"]{
        opacity:1;
        transform: translateY(0) scale(1);
        filter: blur(0);
      }

      /* Soft Packora glow when empty state appears */
      [data-packora-cart-empty][data-pk-visible="1"] .packora-empty-card{
        position:relative;
        isolation:isolate;
      }
      [data-packora-cart-empty][data-pk-visible="1"] .packora-empty-card::before{
        content:"";
        position:absolute;
        inset:-2px;
        border-radius:24px;
        pointer-events:none;
        background: radial-gradient(60% 60% at 50% 20%,
          rgba(0,196,140,.22),
          rgba(47,91,255,.12),
          transparent 70%);
        filter: blur(14px);
        opacity:.85;
        z-index:-1;
        animation: pkGlowPulse 1800ms ease-in-out infinite;
      }
      @keyframes pkGlowPulse{
        0%,100%{ opacity:.65; transform: translateY(0); }
        50%{ opacity:.92; transform: translateY(-1px); }
      }

      /* Button micro-interaction when empty becomes visible */
      [data-packora-cart-empty][data-pk-visible="1"] .packora-empty-btn{
        transition: transform 140ms ease, box-shadow 180ms ease, filter 180ms ease;
      }
      [data-packora-cart-empty][data-pk-visible="1"] .packora-empty-btn:hover{
        transform: translateY(-1px);
        filter: saturate(1.02);
      }
      [data-packora-cart-empty][data-pk-visible="1"] .packora-empty-btn:active{
        transform: translateY(0) scale(.985);
      }

      /* FOOTER: smooth collapse instead of hard hide */
      [data-packora-cart-footer]{
        transition:
          max-height 260ms ease,
          opacity 220ms ease,
          transform 260ms ease;
        transform-origin: top;
      }
      [data-packora-cart-footer][data-pk-collapsed="1"]{
        max-height: 0 !important;
        opacity: 0 !important;
        transform: translateY(-6px) scale(.995);
        overflow: hidden !important;
        pointer-events:none !important;
      }
    `;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  };

  injectMotionCSS();

  // Prep: make footer collapsible without layout jump
  const prepFooter = () => {
    if (!footerEl) return;
    // Only set max-height if not already set (avoid fighting theme CSS)
    if (!footerEl.style.maxHeight) {
      footerEl.style.maxHeight = footerEl.scrollHeight + 'px';
    }
  };

  // Premium show/hide handlers
  const showEmpty = () => {
    if (emptyEl) {
      emptyEl.hidden = false;               // must be visible for animation
      emptyEl.setAttribute('data-pk-visible', '1');
    }
    if (footerEl) {
      prepFooter();
      footerEl.setAttribute('data-pk-collapsed', '1');
    }
    document.documentElement.classList.add('pk-cart-empty');
  };

  const hideEmpty = () => {
    if (emptyEl) {
      emptyEl.removeAttribute('data-pk-visible');
      // Wait for transition then hide for accessibility/tab order
      window.setTimeout(() => {
        // Only hide if still not visible (avoid race conditions)
        if (!emptyEl.hasAttribute('data-pk-visible')) emptyEl.hidden = true;
      }, 280);
    }
    if (footerEl) {
      footerEl.removeAttribute('data-pk-collapsed');
      // restore max-height to current content height so it animates correctly
      window.setTimeout(() => {
        if (!footerEl) return;
        footerEl.style.maxHeight = footerEl.scrollHeight + 'px';
      }, 0);
    }
    document.documentElement.classList.remove('pk-cart-empty');
  };

  const setEmpty = (isEmpty) => {
    if (isEmpty) showEmpty();
    else hideEmpty();
  };

  const sync = async () => {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      setEmpty((cart.item_count || 0) === 0);
    } catch (e) {
      // Fail silently
    }
  };

  // Initial
  sync();

  // After any click that looks like a remove action, resync shortly after
  document.addEventListener('click', (e) => {
    const t = e.target.closest('a, button');
    if (!t) return;

    const looksLikeRemove =
      t.matches('[data-cart-remove], .cart-remove, a[href*="quantity=0"]') ||
      (t.getAttribute('name') || '').toLowerCase().includes('remove');

    if (looksLikeRemove) {
      setTimeout(sync, 180);
      setTimeout(sync, 520);
      setTimeout(sync, 980);
    }
  });

  // If your cart updates DOM via AJAX, this catches it too
  const itemsRoot =
    document.querySelector('cart-items') ||
    document.querySelector('[data-cart-items]') ||
    document.querySelector('form[action^="/cart"]');

  if (itemsRoot) {
    let raf = 0;
    new MutationObserver(() => {
      // throttle to one sync per frame
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }).observe(itemsRoot, { childList: true, subtree: true });
  }

  // Keep footer max-height correct on resize (so collapse animation stays smooth)
  window.addEventListener('resize', () => {
    if (!footerEl) return;
    if (footerEl.getAttribute('data-pk-collapsed') === '1') return;
    footerEl.style.maxHeight = footerEl.scrollHeight + 'px';
  });
})();